<script setup lang="ts">

defineProps({
  active: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
<button :class="{
  'header-btn': true,
  'header-btn-active': active
}">
  <slot></slot>
</button>
</template>

<style scoped lang="scss">
.header-btn {
  @apply py-1 px-2 rounded text-metal-300 transition-all duration-150;
  background: transparent;
  border-bottom: 2px solid transparent;

  :deep(img) {
    filter: drop-shadow(0 1px 1px rgba(0,0,0,0.4));
  }

  &:hover {
    @apply text-white;
    background: rgba(255, 255, 255, 0.05);
  }
}

.header-btn-active {
  @apply text-white;
  border-bottom-color: rgba(59, 130, 246, 0.7);
  text-shadow: 0 0 10px rgba(59, 130, 246, 0.3);
}
</style>